import React, { useState } from 'react';
import { useApp } from '../../../context/AppContext';
import DataTable from '../../../components/DataTable/DataTable';
import StatusBadge from '../../../components/StatusBadge/StatusBadge';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Modal from '../../../components/Modal/Modal';
import './Settlements.css';

const AdminSettlements = () => {
    const { agentReceivables } = useApp();
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const columns = [
        {
            key: 'name',
            label: 'Name',
        },
        {
            key: 'phone',
            label: 'Phone',
        },
        {
            key: 'email',
            label: 'Email',
        },
        {
            key: 'loyalty_points_earned',
            label: 'Loyalty Points Earned',
        },
        {
            key: 'amount_to_be_paid',
            label: 'Amount to be Paid',
            render: (value) => value !== null ? `₹${value.toLocaleString('en-IN')}` : 'N/A',
        },
    ];

    const handleRowClick = (settlement) => {
        setSelectedSettlement(settlement);
        setIsModalOpen(true);
    };

    console.log("agentReceivables::::::", agentReceivables);
    console.log("selectedSettlement::::::", selectedSettlement);

    return (
        <div className="admin-settlements">
            <PageHeader title="Settlements" />

            <DataTable
                columns={columns}
                data={agentReceivables}
                onRowClick={handleRowClick}
                searchable
                searchPlaceholder="Search agents..."
            />

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={`Agent Details - ${selectedSettlement?.name}`}
                size="large"
            >
                {selectedSettlement && (
                    <div className="settlement-details">
                        <div className="settlement-details-section">
                            <h3>Agent Information</h3>
                            <div className="settlement-details-grid">
                                <div>
                                    <label>Name</label>
                                    <p>{selectedSettlement.name}</p>
                                </div>
                                <div>
                                    <label>Phone</label>
                                    <p>{selectedSettlement.phone || 'N/A'}</p>
                                </div>
                                <div>
                                    <label>Email</label>
                                    <p>{selectedSettlement.email}</p>
                                </div>
                                <div>
                                    <label>Loyalty Points Earned</label>
                                    <p>{selectedSettlement.loyalty_points_earned}</p>
                                </div>
                                <div>
                                    <label>Amount to be Paid</label>
                                    <p className="balance-due">{selectedSettlement.amount_to_be_paid !== null ? `₹${selectedSettlement.amount_to_be_paid.toLocaleString('en-IN')}` : 'N/A'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="settlement-note">
                            <p>💡 This view shows the agent's receivable amount details.</p>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default AdminSettlements;

